import styled, { keyframes } from 'styled-components'
import ReactTooltip from 'react-tooltip'
import { Colors } from '../../../styles'

export const TooltipsWrapper = styled.div`
  z-index: 1000;
`

export const Box = styled.div`
  margin-top: 5px;
  margin-bottom: 5px;
`

export const Tooltips = styled(ReactTooltip)`
  min-width: max-content;
  gap: 0.5rem;
  display: flex;
  flex-direction: column;
`
export const TooltipItemWrapper = styled.div`
  display: flex;
  flex-direction: column;
`

export const TittleTooltips = styled.span`
  color: ${Colors.grey};
  font-size: 1rem;
  font-weight: 400;
`

export const ContentTooltips = styled.div`
  font-size: 1rem;
  font-weight: 700;
  color: ${Colors.black};
`

export const Jetty = styled.div`
  z-index: 2;
  display: flex;
  position: absolute;
  align-items: flex-end;
  justify-content: center;
  height: ${(props) => props.height};
  transform: rotate(${(props) => props.rotate || '0deg'});

  &:hover {
    z-index: 3;
  }
`

export const Vessel = styled.img`
  width: ${(props) => props.width || 'auto'};
  height: ${(props) => props.height || '100%'};
  transform-origin: bottom center;
`
const slideUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(10%) scale(0.95);
  }
  to {
    opacity: 1;
    transform: translateY(-50%) scale(1);
  }
`

export const LeftCraneImage = styled.img`
  position: absolute;
  left: -2rem;
  height: 48%;
  top: 50%;
  cursor: pointer;
  transform: translateY(-50%);
  display: ${({ show }) => (show ? 'block' : 'none')};
  animation: ${slideUp} 0.5s cubic-bezier(0.4,0,0.2,1);
`

export const LeftBargeImage = styled.img`
  position: absolute;
  left: ${({ size, hasCrane }) => {
    if (!hasCrane) return '-2rem'
    if (size === 'Small') return '-3.8rem'
    if (size === 'Medium') return '-3.6rem'
    return '-4.3rem'
  }};
  height: 40%;
  top: 50%;
  cursor: pointer;
  transform: translateY(-50%);
  display: ${({ show }) => (show ? 'block' : 'none')};
  animation: ${slideUp} 0.5s cubic-bezier(0.4,0,0.2,1);
`

export const RightCraneImage = styled.img`
  position: absolute;
  right: -2.2rem;
  height: 48%;
  top: 50%;
  cursor: pointer;
  transform: translateY(-50%);
  display: ${({ show }) => (show ? 'block' : 'none')};
  animation: ${slideUp} 0.5s cubic-bezier(0.4,0,0.2,1);
`

export const RightBargeImage = styled.img`
  position: absolute;
  right: ${({ size, hasCrane }) => {
    if (!hasCrane) return '-2.2rem'
    if (size === 'Small') return '-4rem'
    if (size === 'Medium') return '-3.8rem'
    return '-4.5rem'
  }};
  height: 40%;
  top: 50%;
  cursor: pointer;
  transform: translateY(-50%);
  display: ${({ show }) => (show ? 'block' : 'none')};
  animation: ${slideUp} 0.5s cubic-bezier(0.4,0,0.2,1);
`

export const BubbleContainer = styled.div`
  left: 50%;
  position: absolute;
  display: flex;
  gap: 0.5rem;
  bottom: 0.4rem;
  align-items: center;
  flex-direction: column-reverse;
  height: ${(props) => props.height};
  width: ${(props) => props.width};
  z-index: 1000;
  transform: translateX(-50%) scale(1);
`

export const BubbleItem = styled.div`
  width: 100%;
  height: 2.1rem;
  display: flex;
  cursor: pointer;
  box-sizing: border-box;
  border-radius: 999px;
  align-items: center;
  justify-content: start;
  border: 1px solid ${Colors.white};
  background-color: ${Colors.white};
  transform: scale(1) !important;
`
export const BubbleInfoWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 2rem;
  display: flex;
  align-items: center;
`
export const BubbleItemFilled = styled.div`
  top: 0;
  left: 0;
  bottom: 0;
  cursor: pointer;
  position: absolute;
  border-radius: inherit;
  transition: width 0.3s ease;
  background-color: ${Colors.topaz};
  width: ${(props) => (props.percentage > 100 ? 100 : props.percentage || 0)}%;
`
export const BubbleCircleWrapper = styled.div`
  border-top-left-radius: 999px;
  border-bottom-left-radius: 999px;
  background-color: ${(props) =>
    props.percentage ? Colors.topaz : Colors.white};
`

export const BubbleItemFillWrapper = styled.div`
  position: absolute;
  inset: 0px 0px 0px 0px;
  width: 100%;
  border-top-right-radius: 30px;
  border-bottom-right-radius: 30px;
`
export const BubbleCirclePercentage = styled.div`
  width: 2rem;
  height: 2rem;
  display: flex;
  cursor: inherit;
  font-weight: 800;
  font-size: 0.75rem;
  border-radius: 100%;
  align-items: center;
  color: ${Colors.black};
  justify-content: center;
  border: 1px solid ${Colors.white};
  background-color: ${Colors.najavoWhite};
`
export const BubbleDescription = styled.div`
  z-index: 1;
  display: flex;
  cursor: inherit;
  padding: 0px 2px 0px 2px;
  flex-direction: column;
  justify-content: start;
`

export const BubbleValueWrapper = styled.div`
  display: flex;
  cursor: inherit;
  align-items: center;
  justify-content: start;
`

export const BubbleMaxValue = styled.label`
  font-size: 0.75rem;
  cursor: inherit;
  font-weight: 700;
  color: ${Colors.black};
`
export const BubbleValue = styled.label`
  font-size: 0.75rem;
  cursor: inherit;
  font-weight: 600;
  color: ${Colors.black};
`
export const Container = styled.div`
  width: 31rem;
  min-height: 50rem;
  max-height: 50rem;
  border-radius: 0.75rem;
  background: ${Colors.white};
  overflow: auto;
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE 10+ */
  &::-webkit-scrollbar {
    display: none; /* Chrome/Safari/Webkit */
  }
`
export const TableContainer = styled.div`
  padding: 0.75rem;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
`

export const QuantityContainer = styled.div`
  width: 100%;
  display: flex;
  border-top-right-radius: 0.75rem;
  border-top-left-radius: 0.75rem;
`

export const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;
`

export const Quantity = styled.div`
  width: 100%;
  padding: 1vh;
  display: flex;
  font-size: 1rem;
  font-weight: 700;
  text-align: center;
  color: ${Colors.white};
  align-content: center;
  flex-direction: column;
  background: ${Colors.pacificBlue};
  ${({ left, right }) =>
    right
      ? 'border-left: 1px solid white; border-top-right-radius: 0.75rem;'
      : left
      ? 'border-right: 1px solid white; border-top-left-radius: 0.75rem;'
      : ''}
`

export const HeaderContent = styled.div`
  padding: 1vh;
  display: flex;
  align-items: center;
  border-radius: 0.375rem;
  justify-content: space-between;
  background: ${Colors.softBlue};
`
export const TableHead = styled.thead`
  height: fit-content;
`

export const TableTh = styled.th`
  font-size: 1rem;
  font-weight: 700;
  color: ${Colors.darkSlate};
  background: ${Colors.white};
`
export const TableTd = styled.td`
  font-size: 0.75rem;
  font-weight: 700;
  color: ${Colors.darkSlate};
`
export const VesselName = styled.div`
  font-size: 1.25rem;
  font-weight: 700;
  color: ${Colors.white};
`

export const TitleTdContent = styled.div`
  padding: 1vh;
  font-size: 1.25rem;
  font-weight: 700;
  border-radius: 0.5rem;
  color: ${Colors.white};
  background: ${Colors.softBlue};
`

export const ListContainer = styled.div`
  background-color: #efefef;
  padding: 0.75rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  width: 100%;
`

export const Label = styled.label`
  font-weight: 700;
  font-size: 0.875rem;
  color: #3c4447;
`

export const ListFlex = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
`

export const Items = styled.div`
  gap: 0.5rem;
  display: flex;
  align-items: center;
`

export const Color = styled.span`
  width: 0.75rem;
  height: 0.75rem;
  min-height: 0.75rem;
  max-height: 0.75rem;
  min-width: 0.75rem;
  max-width: 0.75rem;
  border-radius: 100%;
  background-color: ${({ color }) =>
    color === 'green'
      ? Colors.badgeCompleted
      : color === 'orange'
      ? Colors.badgeAlongsideMV
      : Colors.badgeQueued};
`

export const Name = styled.span`
  font-size: 0.75rem;
  font-weight: 400;
  color: ${Colors.darkSlate};
`

export const Capacity = styled.span`
  font-size: 0.75rem;
  font-weight: 700;
  color: ${Colors.darkSlate};
`
export const ContainerEquipment = styled.div`
  display: flex;
  gap: 1rem;
  width: 100%;
  padding: 0.75rem;
  flex-direction: column;
`

export const Wrapper = styled.div`
  top: 9rem;
  gap: 2rem;
  right: 2.5rem;
  display: flex;
  position: absolute;
  flex-direction: column;
`
export const Legend = styled.div`
  width: 31rem;
  height: 2rem;
  display: flex;
  align-items: center;
  border-radius: 0.75rem;
  background: ${Colors.white};
  justify-content: space-around;
`
export const LegendItem = styled.div`
  display: flex;
  gap: 0.5rem;
  font-weight: 400;
  font-size: 0.8125rem;
  align-items: center;
  color: ${Colors.darkSlate};
`
export const WarningIcon = styled.img`
  width: 1.5rem;
  height: 1.5rem;
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
  cursor: pointer;
`
export const Title = styled.div`
  text-align: center;
  font-size: 24px;
  font-weight: 700;
  width: 100%;
  color: ${Colors.cancelTextColor};
`

export const Description = styled.div`
  text-align: center;
  font-size: 16px;
  font-weight: 500;
  width: 100%;
  margin-top: 8px;
  color: ${Colors.modalGrey};
`
export const Centered = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`
export const CenteredButton = styled.div`
  display: flex;
  margin-top: 1rem;
  justify-content: center;
  align-items: center;
`
export const IconImage = styled.img`
  width: 6rem;
  height: 6rem;
`
export const ContainerWarning = styled.div`
  padding: 2rem 0px;
`

export const AccordionButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  transition: transform 0.2s;
  svg {
    transition: transform 0.2s;
    transform: rotate(${(props) => (props.open ? '180deg' : '0deg')});
  }
`
export const ContainerTable = styled.div`
  padding-inline: 0.75rem;
`

export const JettyMaps = styled.div`
  top: 50%;
  left: 50%;
  display: flex;
  position: absolute;
  flex-direction: row;
  border: 0.25rem dashed white;
  transform: translate(-50%, -50%);
  background: rgba(92, 102, 109, 0.5);
`
export const Sidebar = styled.div`
  color: white;
  width: 8.5rem;
  display: flex;
  padding: 1rem;
  position: relative;
  font-size: 0.75rem;
  align-items: center;
  flex-direction: column;
  justify-content: space-between;
  border-right: 0.25rem dashed white;
`
export const Cell = styled.div`
  color: white;
  display: flex;
  width: 19.1875rem;
  height: 15.4375rem;
  position: relative;
  font-size: 0.75rem;
  align-items: center;
  justify-content: center;
  border-right: ${({ borderRight }) =>
    borderRight ? '0.25rem dashed white' : 'none'};
  border-bottom: ${({ borderBottom }) =>
    borderBottom ? '0.25rem dashed white' : 'none'};
`
export const JettyName = styled.div`
  top: 0.5rem;
  left: 0.5rem;
  position: absolute;
`
export const Column = styled.div`
  display: flex;
  flex-direction: column;
`
